import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

/**
 * PageShell — mobile-first premium page container.
 * Renders top nav, header (kicker + title + subtitle + optional actions) and content.
 */
export default function PageShell({ kicker, title, sub, actions, testId, children, maxWidth = "max-w-6xl" }) {
    return (
        <div className="min-h-screen bg-paw-bone dark:bg-[hsl(152,15%,8%)] text-paw-ink dark:text-paw-bone" data-testid={testId}>
            <Nav />
            <main className={`pt-24 sm:pt-28 pb-24 ${maxWidth} mx-auto px-4 sm:px-6 lg:px-8`}>
                {(kicker || title || sub || actions) && (
                    <header className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                        <div>
                            {kicker && (
                                <p className="label-soft uppercase text-paw-ink2 dark:text-paw-bone/60">{kicker}</p>
                            )}
                            {title && (
                                <h1 className="mt-1 font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-paw-ink dark:text-paw-bone">
                                    {title}
                                </h1>
                            )}
                            {sub && (
                                <p className="mt-2 text-sm sm:text-base text-paw-ink2 dark:text-paw-bone/60 max-w-2xl">{sub}</p>
                            )}
                        </div>
                        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
                    </header>
                )}
                {children}
            </main>
            <Footer />
        </div>
    );
}
